'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixAll;

var _prefixProps = require('./prefixProps');

var _prefixProps2 = _interopRequireDefault(_prefixProps);

var _capitalizeString = require('../utils/capitalizeString');

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

var _assign = require('../utils/assign');

var _assign2 = _interopRequireDefault(_assign);

var _calc = require('./plugins/calc');

var _calc2 = _interopRequireDefault(_calc);

var _cursor = require('./plugins/cursor');

var _cursor2 = _interopRequireDefault(_cursor);

var _flex = require('./plugins/flex');

var _flex2 = _interopRequireDefault(_flex);

var _sizing = require('./plugins/sizing');

var _sizing2 = _interopRequireDefault(_sizing);

var _gradient = require('./plugins/gradient');

var _gradient2 = _interopRequireDefault(_gradient);

var _transition = require('./plugins/transition');

var _transition2 = _interopRequireDefault(_transition);

var _flexboxIE = require('./plugins/flexboxIE');

var _flexboxIE2 = _interopRequireDefault(_flexboxIE);

var _flexboxOld = require('./plugins/flexboxOld');

var _flexboxOld2 = _interopRequireDefault(_flexboxOld);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// special flexbox specifications


var plugins = [_calc2.default, _cursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default, _flex2.default];

/**
 * Returns a prefixed version of the style object using all vendor prefixes
 * @param {Object} styles - Style object that gets prefixed properties added
 * @returns {Object} - Style object with prefixed properties and values
 */
function prefixAll(styles) {
  Object.keys(styles).forEach(function (property) {
    var value = styles[property];
    if (value instanceof Object && !Array.isArray(value)) {
      // recurse through nested style objects
      styles[property] = prefixAll(value);
    } else if (Array.isArray(value)) {
      // prefix fallback arrays
      (0, _assign2.default)(styles, prefixArray(property, value));
    } else {
      Object.keys(_prefixProps2.default).forEach(function (prefix) {
        var properties = _prefixProps2.default[prefix];
        // add prefixes if needed
        if (properties[property]) {
          styles[prefix + (0, _capitalizeString2.default)(property)] = value;
        }
      });
    }
  });

  Object.keys(styles).forEach(function (property) {
    var value = styles[property];
    // resolve every special plugins
    plugins.forEach(function (plugin) {
      return (0, _assign2.default)(styles, plugin(property, value));
    });
  });

  return styles;
}

function prefixArray(property, valueArray) {
  var result = {};
  valueArray.forEach(function (value) {
    plugins.forEach(function (plugin) {
      var prefixed = plugin(property, value);
      if (prefixed) {
        Object.keys(prefixed).forEach(function (prop) {
          var entry = prefixed[prop];
          result[prop] = result[prop] ? mergeValues(result[prop], entry) : entry;
        });
      }
    });
    if (!result[property]) {
      result[property] = value;
    }
  });
  return result;
}

function mergeValues(existing, toMerge) {
  var merged = existing;
  var valuesToMerge = Array.isArray(toMerge) ? toMerge : [toMerge];
  valuesToMerge.forEach(function (value) {
    if (Array.isArray(merged) && merged.indexOf(value) === -1) {
      merged.push(value);
    } else if (merged !== value) {
      merged = [merged, value];
    }
  });
  return merged;
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/inline-style-prefixer/lib/static/prefixAll.js
 ** module id = 8
 ** module chunks = 0
 **/